import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import { withEmitter } from '../HoC';

export class EmitterRedirect extends Component {
  static propTypes = {
    emitter: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  };

  state = {
    shouldRedirect: false,
    to: null,
  };

  componentDidMount() {
    this.props.emitter.on('redirect', ({ to }) => {
      this.setState({ to, shouldRedirect: true }, () => {
        this.setState({ to: null, shouldRedirect: false });
      });
    });
  }

  render() {
    const { to, shouldRedirect } = this.state;
    return shouldRedirect ? (
      <Redirect
        to={{
          pathname: to,
          state: { from: this.props.location },
        }}
      />
    ) : null;
  }
}

export default withRouter(withEmitter(EmitterRedirect));
